export default "__VITE_ASSET__Bn89Nhgu__"